// Campus photo for /colleges/middlebury-college: CC BY-SA 4.0, by Niranjan Arminius, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AMiddleburyCollege_MeadChapelOblique_20160929.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/middlebury-college/; credited under the photo.
const photo = {
    "slug": "middlebury-college",
    "alt": "Mead Memorial Chapel at Middlebury College in Middlebury, Vermont",
    "src": "/colleges/middlebury-college/campus-1600.webp",
    "srcSmall": "/colleges/middlebury-college/campus-800.webp",
    "srcMid": "/colleges/middlebury-college/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/middlebury-college/og.jpg",
    "title": "MiddleburyCollege MeadChapelOblique 20160929",
    "author": "Niranjan Arminius",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AMiddleburyCollege_MeadChapelOblique_20160929.jpg",
    "read": "2026-10-01"
};

export default photo;
